"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyerSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.BuyerSchema = __1.BaseSchema.partial().extend({
    nickname: __1.ShortStringSchema.optional(),
    firstName: __1.ShortStringSchema.optional(),
    lastName: __1.ShortStringSchema.optional(),
    email: __1.LongStringSchema.email().optional(),
    phone: __1.PhoneSchema.partial().optional(),
    alternativePhone: __1.PhoneSchema.partial().optional(),
    channelBuyerId: __1.ShortStringSchema.optional(),
    billingAddress: __1.AddressSchema.optional(),
    isBillingAddressTheShippingAddress: zod_1.z.boolean().optional(),
    taxId: __1.ShortStringSchema.optional(),
    taxIdType: zod_1.z.nativeEnum(__1.TaxIdType).optional(),
});
//# sourceMappingURL=buyer.js.map